import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=c81d1304&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d1304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81d1304')) {
      api.createRecord('c81d1304', component.options)
    } else {
      api.reload('c81d1304', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=c81d1304&scoped=true&", function () {
      api.rerender('c81d1304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21jfgjCJGzf73/JS/comp/Voucher-Unit.vue"
export default component.exports